
<div class="card-wrapper">
    <div class="card-content">

        <!-- Content-Bereich (rechts) -->
        <div class="content-section">
            <!-- Kopfbereich -->
            <div class="header-section">
                <div class="title-row">
                    <h2 class="card-title" id="ausschreibungName">{{ ausschreibungsName }}</h2>
                </div>
                <span class="status-badge status-open" *ngIf="isPermanentOpen">
                    {{'tender.status.open' | translate}}
                </span>
                <span class="status-badge status-open" *ngIf="isOpen">
                    {{ 'tender.status.open_until' | translate }}: {{ ausschreibung.dateTo | date: languageService.GetCurrentShortDateFormatWithTime()}}
                </span>
                <span class="status-badge status-closed" *ngIf="!isInPreview && !isNotYetOpen && isExpired && !isPermanentOpen">
                    {{'tender.status.closed' | translate}}
                </span>
                <span class="status-badge status-soon" *ngIf="isNotYetOpen">
                    {{ 'tender.status.notyetOpen' | translate }}: {{ ausschreibung.dateFrom | date: languageService.GetCurrentShortDateFormatWithTime()}}
                </span>
                <span class="status-badge status-planning" *ngIf="isInPreview">
                    {{'tender.status.inPlanning' | translate}}
                </span>
            </div>

        </div>
        <!-- Icon-Bereich (rechts) -->
        <div class="icon-section" *ngIf="isLogoVisible(ausschreibung)">
            <div class="icon-container">
                <img *ngIf="isLogoVisible(ausschreibung)" [src]="getLogo(ausschreibung)" aria-label="logo" alt="logo" class="icon-image">
            </div>
        </div>
    </div>        
    <!-- Beschreibungstext -->
    <div class="description-section">
        <p class="description-text" *ngIf="isProjektbeschreibungVisible" [trimRichtextAriaLabel]="getGoalDescriptionText(ausschreibung)" [innerHTMLBypassXSS]="getGoalDescriptionText(ausschreibung)"></p>
        <span class="description-text" *ngIf="isNoDescriptionMessageVisible">{{ 'tender.no_description_available' | translate}}</span>
    </div>

    <!-- Aktionsbereich -->

    <div class="actions-section">
        @if (ausschreibung.unterlagenVorhanden) {
            <button 
                kendoButton
                (click)="openUnterlagenDialog(ausschreibung.id)" 
                class="btn-ghost">
                <lucide-icon name="download" [size]="16"></lucide-icon>
                <span>{{'ausschreibung.unterlagen.open-dialog' | translate}}</span>
            </button>
        }
        <button 
            [disabled]="!canApply"
            kendoButton
            (click)="onCreateClick()" 
            [attr.aria-label]="getApplyButtonAriaText()" 
            class="btn-primary">
            <span>{{getApplyButtonText}}</span>
            <lucide-icon name="arrow-right" [size]="16" class="arrow-icon"></lucide-icon>
        </button>
    </div>
</div>
